import wrapError from "@/components/helpers/wrapError"

export const fetchSearchResults = (params, success, error) => {
  const { query, page, filters, userInitiated, searchLocation } = params
  const payload = {
    query: encodeURIComponent(query),
    page: page || 0,
    searchLocation: searchLocation || null,
  }

  if (filters) {
    payload.filters = filters
  }
  if (userInitiated) {
    payload.userInitiated = true
  }
  $.ajax({
    type: "GET",
    url: "/api/search",
    dataType: "JSON",
    data: payload,
    success,
    error: wrapError(error, "fetchSearchResults"),
  })
}

export const apiFetchSelectedUser = (userId, customerId, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/selectedUser/${userId}?customerId=${customerId}`,
    success,
    error: wrapError(error, "apiFetchSelectedUser"),
  })
}

export const apiFetchRecentSearches = (success, error) => {
  $.ajax({
    type: "GET",
    url: "api/searchHistory",
    success,
    error: wrapError(error, "apiFetchRecentSearches"),
  })
}

export const apiFetchSearchSuggestions = (query, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/search/searchAutocompleteManager/?query=${encodeURIComponent(query)}`,
    success,
    error: wrapError(error, "apiFetchSearchSuggestions"),
  })
}

export const apiFetchSuggestedSearches = (page, success, error) => {
  $.ajax({
    type: "GET",
    url: `/api/suggestedSearchManager?page=${page || 0}`,
    success,
    error: wrapError(error, "apiFetchSuggestedSearches"),
  })
}

export const apiFetchMapLocations = (query, filters, success, error) => {
  const payload = { query }

  if (filters) {
    payload.filters = filters
  }
  $.ajax({
    type: "GET",
    url: "/api/map",
    dataType: "JSON",
    data: payload,
    success,
    error: wrapError(error, "fetchMapLocations"),
  })
}
